import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';

export function Footer() {
  const { t, currentLanguage } = useLanguage();
  const currentYear = new Date().getFullYear();

  const taglines = {
    en: 'Engineering Intelligent Software',
    tr: 'Akıllı Yazılım Mühendisliği',
    de: 'Entwicklung Intelligenter Software'
  };

  const legalNote = {
    en: 'Datex Systems is operated by Datex Bilişim AŞ.',
    tr: 'Datex Systems, Datex Bilişim AŞ tarafından işletilmektedir.',
    de: 'Datex Systems wird von Datex Bilişim AŞ betrieben.'
  };

  const navLabel = {
    en: 'Navigation',
    tr: 'Navigasyon',
    de: 'Navigation'
  };

  const connectLabel = {
    en: 'Connect',
    tr: 'İletişim',
    de: 'Kontakt'
  };

  return (
    <footer
      data-testid="footer"
      className="relative py-12"
      style={{ 
        background: '#0A0E12',
        borderTop: 'none'
      }}
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Left - Company Identity */}
          <div>
            <Link to="/" className="inline-block mb-3">
              <span 
                className="text-base font-semibold tracking-tight"
                style={{ color: 'var(--text-primary)' }}
              >
                DATEX
              </span>
            </Link>
            <p 
              className="text-xs mb-4"
              style={{ color: 'var(--text-subtle)', fontFamily: 'JetBrains Mono, monospace' }}
            >
              {taglines[currentLanguage] || taglines.en}
            </p>
            <p 
              className="text-xs"
              style={{ color: 'var(--text-subtle)' }}
            >
              {legalNote[currentLanguage] || legalNote.en}
            </p>
          </div>

          {/* Center - Quick Links */}
          <div className="flex flex-col gap-2">
            <span 
              className="text-xs uppercase tracking-widest mb-2"
              style={{ color: 'var(--text-subtle)' }}
            >
              {navLabel[currentLanguage] || navLabel.en}
            </span>
            <Link 
              to="/systems" 
              className="text-xs transition-colors duration-300 hover:text-[#14B8A6]"
              style={{ color: 'var(--text-muted)' }}
            >
              Systems
            </Link>
            <Link 
              to="/case-studies" 
              className="text-xs transition-colors duration-300 hover:text-[#14B8A6]"
              style={{ color: 'var(--text-muted)' }}
            >
              {t('nav.caseStudies')}
            </Link>
            <Link 
              to="/contact" 
              className="text-xs transition-colors duration-300 hover:text-[#14B8A6]"
              style={{ color: 'var(--text-muted)' }}
            >
              {t('nav.contact')}
            </Link>
          </div>

          {/* Right - Contact */}
          <div className="flex flex-col gap-2">
            <span 
              className="text-xs uppercase tracking-widest mb-2"
              style={{ color: 'var(--text-subtle)' }}
            >
              {connectLabel[currentLanguage] || connectLabel.en}
            </span>
            <a 
              href="mailto:info@datexsystems.com" 
              className="text-xs flex items-center gap-2 transition-colors duration-300"
              style={{ color: 'var(--text-muted)' }}
            >
              <Mail className="w-3 h-3" />
              info@datexsystems.com
            </a>
            <a 
              href="https://linkedin.com/company/datex-systems" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs flex items-center gap-2 transition-colors duration-300"
              style={{ color: 'var(--text-muted)' }}
              data-testid="footer-linkedin"
            >
              <Linkedin className="w-3 h-3" />
              LinkedIn
            </a>
          </div>
        </div>

        {/* Bottom - Copyright */}
        <div 
          className="mt-10 pt-6 border-t flex flex-col md:flex-row items-center justify-between gap-3"
          style={{ borderColor: 'var(--border-subtle)' }}
        >
          <div 
            className="text-xs"
            style={{ color: 'var(--text-subtle)' }}
          >
            © {currentYear} Datex Bilişim AŞ. {t('footer.rights')}
          </div>
          <div 
            className="text-xs"
            style={{ color: 'var(--text-subtle)', fontFamily: 'JetBrains Mono, monospace' }}
          >
            datexsystems.com
          </div>
        </div>
      </div>
    </footer>
  );
}
